import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FareFamilyComponent } from './fare-family.component';
import { FareFamilyService } from './fare-family.service';
import { FareFamilyDescriptionDialogComponent } from './fare-family-description-dialog.component';
import { BtnModule } from '../../ui_button/btn.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { LocalizedModule } from 'libraries/pipes/localized/localized.module';
import { PriceModule } from '../price/price.module';
import { DeltaPriceModule } from 'libraries/hotel/components/delta-price/delta-price.module';

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        BtnModule,
        LocalizedModule,
        MatTooltipModule,
        OverlayModule,
        PriceModule,
        DeltaPriceModule,
    ],
    declarations: [
        FareFamilyComponent,
        FareFamilyDescriptionDialogComponent,
    ],
    exports: [
        FareFamilyComponent,
        FareFamilyDescriptionDialogComponent,
    ],
    providers: [
        FareFamilyService
    ]
})
export class FareFamilyModule {}